module.exports = __webpack_public_path__ + "static/part-9-36affdcecd1dc39aba57fea373cacda2.svg";